import { faFilter, faFilterList, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { statisticsMessages } from 'src/features/statistics/utils';
import { tableMessages } from 'src/registry/components/table';
import { Button } from 'src/registry/ui/Button';
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItemWithIcon,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from 'src/registry/ui/DropdownMenu';

import type { ListResponseSmartParkAPI } from 'src/types';

type StatisticsDropdownProps = {
    selectedIds: string[];
    setSelectedIds: (id: string[]) => void;
    data: ListResponseSmartParkAPI<{ name: string; id: string }> | undefined;
};
export default function StatisticsZoneDropdown(props: StatisticsDropdownProps) {
    const { formatMessage } = useIntl();
    const { selectedIds, setSelectedIds, data } = props;
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="xsIcon">
                    <FontAwesomeIcon
                        className="text-primary-700"
                        icon={!selectedIds.length || selectedIds.length === data?.count ? faFilterList : faFilter}
                    />
                    <span className="xs:block hidden">{formatMessage(statisticsMessages.parkingZones)}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-56">
                <DropdownMenuGroup>
                    {data?.results.map((item) => {
                        return (
                            <DropdownMenuCheckboxItem
                                key={item.id}
                                checked={selectedIds.includes(item.id)}
                                onSelect={(e) => e.preventDefault()}
                                onCheckedChange={(value) => {
                                    if (value) return setSelectedIds([...selectedIds, item.id]);
                                    const newIds = selectedIds.filter((id) => id !== item.id);
                                    return setSelectedIds(newIds);
                                }}
                            >
                                {item.name}
                            </DropdownMenuCheckboxItem>
                        );
                    })}
                </DropdownMenuGroup>
                <DropdownMenuSeparator />
                <DropdownMenuItemWithIcon
                    variant="destructive"
                    icon={faTrashAlt}
                    onSelect={() => setSelectedIds([])}
                    disabled={!selectedIds.length}
                >
                    {formatMessage(tableMessages.clearFilter)}
                </DropdownMenuItemWithIcon>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
